import api from '@/api/role'
import { errorHandler } from '../exports/error_management'

import { StorageCache } from '../exports/dataStorage'
const storageKey = 'ams-roles-key'

const state = {
    item: null,
    items: [],
    roles: [],
    pagination: null,
    role_filter : null,
}

const mutations = {
    set_item(state, payload) {
        state.item = payload
    },
    set(state, payload) {
        state.items = payload
    },
    delete(state, id) {
        let index = state.items.findIndex(x => x.id == id)
        state.items.splice(index, 1)
        console.log('deleted item at index ' + index)
    },
    set_pagination(state, pag) {
        state.pagination = pag
    },
    set_roles(state,payload){
        state.roles = payload
    },
    SET_ROLE_FILTERS(state,filter){
        state.role_filter = filter;
      }
}

const actions = {
    async create(context, payload) {
        new StorageCache(storageKey).reset()
        await api.create(payload)
    },

    async fetch(context, payload) {
        try {
            const {
                data: {
                    success: { data: pag },
                },
            } = await api.fetch(payload.query, payload.page)

            let items = pag.data

            context.commit('set', items)
            //let pag = result.data.success.data
            context.commit('set_pagination', {
                page: pag.current_page,
                pageSize: pag.per_page,
                total: pag.total,
            })
        } catch (err) {
            errorHandler(err)
        }
    },
    async fetchAll(context) {
        const storageCache = new StorageCache(storageKey)
        try {
            const { is_valid, value } = storageCache.getArray()
            if (!is_valid) {
                const {
                    data: {
                        success: { data },
                    },
                } = await api.fetchAll()

                console.log('role data', data)
                storageCache.set(data)
                value.splice(0)
                value.push(...data)
            }
            context.commit('set', value)
        } catch (err) {
            errorHandler(err)
        }
    },
    async fetchAllDropdown() {
      
        try {
          
                const {
                    data: {
                        success: { data },
                    },
                } = await api.fetchAll()

              if(data){
                return data;
              }else{
                return [];
              }
        } catch (err) {
            errorHandler(err)
        }
    },
    fetchById(context, id) {
        console.log('id', id)
        return api
            .fetchById(id)
            .then(
                ({
                    data: {
                        success: { data },
                    },
                }) => {
                    console.log('assumed role', data)
                    context.commit('set_item', data)
                }
            )
            .catch(err => {
                errorHandler(err)
            })
    },
    async update(context, payload) {
        try {
            new StorageCache(storageKey).reset()
            return await api.update(payload.id, payload)
        } catch (err) {
            errorHandler(err)
        }
    },
    delete(context, id) {
        console.log('deleting',id)
        new StorageCache(storageKey).reset()
        return api
            .delete(id)
            .then(() => {
                context.commit('delete', id)
            })
            .catch(err => {
                errorHandler(err)
            })
    },
    async fetch_roles(context, payload) {
        let  payload_data = payload;
        try {
            const {
                data: {
                    success: { data },
                },
            }  = await api.fetchAll()

            
            console.log('this is items-----',data);
            context.commit('set_roles', data)
            
        
        } catch (err) {
            errorHandler(err)
        }
    },
    async ExportExcel(context,payload){
        try {
           
            let query = payload.query || "";
      
            const response = await api.exportExcel(query);
            const blob = new Blob([response.data], {
              type:
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "Roles.xlsx");
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
          } catch (err) {
            console.error("Error fetching request:", err);
          }

    },

    async sampleExcel(context,payload){
        try {
            let labels = payload.labels;
            const response = await api.exportSampleExcel(labels);
            const blob = new Blob([response.data], {
              type:
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "Roles_Sample.xlsx");
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
          } catch (err) {
            console.error("Error fetching request:", err);
          }

    },
    async upload(context,param){
        try {
          const result  = await api.upload(param);
          console.log('result---',result);
            
           
        } catch (err) {
            errorHandler(err)
        }
    },
    set_role_filter(context,payload){
        context.commit('SET_ROLE_FILTERS', payload)
    },

    async exportExcelCSV(context, {filters_r }) {
        try {
            filters_r = filters_r || '';
        
    
          const response = await api.exportExcelCSV(filters_r);
          const blob = new Blob([response.data], {
            type:
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "roles.csv");
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        } catch (err) {
          console.error("Error fetching request:", err);
        }
      },
}

const getters = {
    roles(state) {
        return state.items
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}
